module.exports = __webpack_public_path__ + "img/blog-20-1.54b322d5.webp";